import React from 'react';
import { useLocation } from 'react-router-dom';

const GoBackArrow = ({ onBack }) => {
  const location = useLocation();

  const handleClick = (e) => {

    // Prevent parent handlers from also acting on this click
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
    }

    if (onBack && typeof onBack === 'function') {
      try {
        onBack();
      } catch (err) {
        console.error('GoBackArrow: error calling onBack prop', err);
      }
    } else {
      // Fallback to history navigation
      try {
        window.history.go(-1);
      } catch (err) {
        console.error('GoBackArrow: error calling history.go', err);
      }
    }
  };

  return (
    <div
      className="allow-pointer-cursor d-block d-sm-inline pe-2"
      onClick={handleClick}
    >
      <i
        title="Regresar"
        style={{ fontSize: '1.5rem' }}
        className="color-gris-megatone fa fa-arrow-left"
      />
    </div>
  );
};

export default GoBackArrow;